import api from './api';

export const formService = {
  async getFormTemplate(country, visaType) {
    const response = await api.get(`/forms/template/${country}/${visaType}`);
    return response.data;
  },

  async generateForm(country, visaType, isPremium = false) {
    const response = await api.post(`/forms/generate/${country}/${visaType}`, { isPremium });
    return response.data;
  },

  async saveApplication(country, visaType, formData) {
    const response = await api.post(`/forms/save/${country}/${visaType}`, { formData });
    return response.data;
  },

  async getApplications() {
    const response = await api.get('/forms/applications');
    return response.data;
  },

  async getApplication(id) {
    const response = await api.get(`/forms/applications/${id}`);
    return response.data;
  }
};